<!--
 * @Author: wangjiaxiang
 * @Date: 2022-04-06 10:38:22
 * @LastEditTime: 2022-10-24 20:03:25
 * @LastEditors: taoyan taoyan_work@163.com
 * @Description:
 * @FilePath: /大增长星妈会C端/xmh-front-content/src/components/home/informationList/index.vue
 *
-->
<template>
  <div class="information-list">
    <!-- <div class="content"> -->
    <van-list
      v-model="pageWikipediaParams.loading"
      :error.sync="pageWikipediaParams.error"
      :finished="pageWikipediaParams.finished"
      :finished-text="pageWikipediaParams.bottomText"
      :immediate-check="false"
      error-text="请求失败，点击重新加载"
      @load="getArticleList()"
    >
      <waterfallComponents
        ref="waterfall"
        class="information-water-fall"
        @clickHander="clickHander"
        @styleEnd="styleEnd"
      >
        <template slot-scope="props">
          <div
            :data="JSON.stringify(setBuiedParasm(props.data))"
            class="water-fall-li"
          >
            <div :class="props.data.jumpType?'water-burial-point':''" :databanner="JSON.stringify({...resourceNiche(props.data),xmh5_ziyuanwei_position: props.index+1})">
              <div
                  :data="
                JSON.stringify({
                  ...getBuiedPointObj(props.data, props.index),
                  moduleType: props.data.columnId,
                })
              "
                  :fromHomeInformation="true"
                  :index="props.index"
                  class="information-info"
              >
                <div
                    v-lazy:background-image="props.data.coverUrl"
                    :class="['info-img',!props.data.jumpType?'information-type-' + props.data.columnId:'',props.data.jumpType?'jumpHeight':'']"
                >
                  <!-- 星妈课堂  columnId == 5 -->
                  <p v-if="!props.data.jumpType && props.data.columnId == 7" class="play-status">
                  <span
                      v-if="
                      compareDate(props.data.startTime, props.data.endTime) == 1
                    "
                  >{{
                      formatDate(
                          'MM月dd日 HH:mm',
                          new Date(props.data.startTime)
                      )
                    }}</span
                  >
                    <span
                        v-if="
                      compareDate(props.data.startTime, props.data.endTime) == 2
                    "
                        class="playing"
                    >
                    <img
                        alt="playing"
                        class="gitImage"
                        src="@/assets/images/common/playing.gif"
                    />
                    直播中
                  </span>
                    <span
                        v-if="compareDate(props.data.startTime, props.data.endTime) == 3"
                    >回放</span
                    >
                  </p>
                  <!-- 播放按钮 -->
                  <img
                      v-if="!props.data.jumpType && props.data.columnId == 5"
                      alt="play"
                      class="play-btn"
                      src="@/assets/images/nweHome/new-play.png"
                  />
                </div>
                <div class="bottom-content" v-if="(props.data.jumpType && props.data.resTitle) || !props.data.jumpType">
                  <!-- 标题 -->
                  <p :class="['item-title', props.data.resTitle ? 'res_title' : '' ]">
                    {{ props.data.jumpType ? props.data.resTitle : props.data.title }}
                  </p>
                  <!-- 商品价格 -->
                  <div v-if="props.data.columnId == 18 && !props.data.jumpType" class="commodity-price">
                    <div class="discounted-price">
                      {{ props.data.finalPrice }}
                    </div>

                    <!-- <span class="original-price"
                    >￥{{ props.data.lineValue || 0 }}</span
                    > -->
                  </div>
                  <div v-if="props.data.columnId != 18 && !props.data.jumpType" class="item-tagAndPlaynum">
                  <span v-if="props.data.tagName" class="item-tag">{{
                      props.data.tagName
                    }}</span>
                    <p class="item-playnum">
                      <img
                          class="icon"
                          src="@/assets/images/nweHome/shoucang.png"
                      />
                      <span
                          v-if="
                        props.data.contentType && props.data.contentType == 1
                      "
                      >{{ fomatterNum(props.data.clickNum) || 0 }}</span
                      >
                      <span v-else>{{
                          fomatterNum(props.data.likeNum || props.data.signUpNum) ||
                          0
                        }}</span>
                    </p>
                  </div>
                </div>
                <template v-if="!props.data.jumpType">
                  <!-- 18为商品 -->
                  <div v-if="props.data.columnId == 18" class="information-wxtag">
                    <openWxTag
                        :id="'information' + props.data.productId + props.index"
                        :path="
                    '/subPackages/shopMainProcess/product/index?productId=' +
                    props.data.productId +
                    '&skuId=' +
                    props.data.skuId +
                    '&actionLinkCode=10013'
                  "
                        btnStyle="width:100%;height:200px"
                        :appId="props.data.miniProgramTypeAppId"
                        @sensorsFn="moduleType11sensors(props.data, props.index)"
                    ></openWxTag>
                  </div>
                </template>
                <!-- 如配置的是小程序的路径，则显示该部分-->
                <template
                    v-if="
                  !props.data.jumpType && (props.data.columnId == 19 || (props.data.columnId == 17 && props.data.classify == 4 && props.data.jumpType == 1)) &&
                  !/(http|https):\/\/([\w.]+\/?)\S*/.test(
                    props.data.contentUrl
                  )
                "
                >
                  <div class="information-wxtag">
                    <openWxTag
                        :id="'information' + props.data.id + props.index"
                        :path="
                      props.data.columnId == 17 && props.data.skuId
                        ? '/subPackages/shopMainProcess/product/index.html?productId=' +
                          props.data.productId +
                          '&skuId=' +
                          props.data.skuId +
                          '&actionLinkCode=10013'
                        : props.data.contentUrl
                    "
                        btnStyle="width:100%;height:200px"
                        :appId="props.data.miniProgramTypeAppId"
                        @sensorsFn="
                      BuiedPointClick_Fn(
                        'xmhh5_home_feeds_click',
                        getBuiedPointObj(props.data, props.index)
                      )
                    "
                    ></openWxTag>
                  </div>
                </template>
                <template v-if="props.data.jumpType === 3">
                  <div class="information-wxtag">
                    <openWxTag
                        :id="'information'+props.data.id"
                        :path="props.data.jumpTargetUrl"
                        :appId="props.data.miniProgramTypeAppId"
                        btnStyle="width:100%;height:300px"
                        @sensorsFn="ResourceBurial(props.data,props.index)"
                    ></openWxTag>
                  </div>
                </template>
              </div>
            </div>

          </div>
        </template>
      </waterfallComponents>
      <template #finished>
        <img
          class="icon"
          src="@/assets/images/expertsView/pentagram.png"
          style="width: 9px"
        />
        我们会加油更新的 么么哒~
        <img
          class="icon"
          src="@/assets/images/expertsView/pentagram.png"
          style="width: 9px"
        />
      </template>
    </van-list>
    <!-- </div> -->
  </div>
</template>

<style lang="less" scoped>
@import './less/index.less';
</style>

<script>
import Index from './js/index.js'

export default Index
</script>
